import { Volume2, VolumeX, Square } from "lucide-react";

// Per-assistant-message speaker control. Never autoplays.
//
// Props:
//   id            — stable message id for playback tracking
//   text          — plain text to speak (assistant body)
//   supported     — SpeechSynthesis available at all
//   turkishAvailable — a Turkish voice is exposed by the OS
//   speakingId    — currently active playback id (from hook)
//   onSpeak(id, text) — start playback of this message
//   onStop()          — cancel current playback
export function SpeakButton({
  id,
  text,
  supported = true,
  turkishAvailable = true,
  speakingId = null,
  onSpeak,
  onStop,
}) {
  const isDisabled = !supported || !turkishAvailable || !text || !text.trim();
  const isSpeaking = supported && speakingId === id;

  let title = "Yanıtı sesli dinle";
  if (!supported) title = "Bu tarayıcı sesli okumayı desteklemiyor";
  else if (!turkishAvailable) title = "Bu cihazda Türkçe ses bulunamadı";
  else if (isSpeaking) title = "Sesli okumayı durdur";

  return (
    <button
      type="button"
      onClick={() => (isSpeaking ? onStop?.() : onSpeak?.(id, text))}
      disabled={isDisabled}
      title={title}
      aria-label={title}
      aria-pressed={isSpeaking}
      className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full bg-white border text-xs transition-colors ${
        isDisabled
          ? "border-zinc-200 text-zinc-300 cursor-not-allowed"
          : isSpeaking
            ? "border-[#1E3A8A]/30 text-[#1E3A8A] bg-[#1E3A8A]/5 hover:bg-[#1E3A8A]/10"
            : "border-zinc-200 text-zinc-600 hover:text-zinc-900 hover:border-zinc-300"
      }`}
      data-testid={`voice-speak-${id}`}
      data-voice-speaking={isSpeaking ? "true" : "false"}
    >
      {isSpeaking ? (
        <>
          <Square className="w-3 h-3" /> Durdur
        </>
      ) : !supported || !turkishAvailable ? (
        <>
          <VolumeX className="w-3 h-3" /> Sesli oku
        </>
      ) : (
        <>
          <Volume2 className="w-3 h-3" /> Sesli oku
        </>
      )}
    </button>
  );
}
